<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-4" v-if="$store.getters.hasCapabilities('invoice_create')">
        <div class="card mb-3" >
          <div class="card-body d-flex justify-content-start">
            <div class="m-2" v-if="$store.getters.hasCapabilities('invoice_create')">
              <span ><a :href="getIntuitURL()" >Authenticate</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/_services'
export default {
  name: 'intuit-login',
  methods: {
    getIntuitURL () {
      return 'https://appcenter.intuit.com/connect/oauth2' +
        '?response_type=code' +
        '&state=oc0CqpMuCWhLci5TpsAeb6raJXUsDV' +
        '&scope=com.intuit.quickbooks.accounting' +
        '&client_id=' + process.env.QB_CLIENT_ID +
        '&redirect_uri=' + encodeURIComponent(process.env.ROOT_URL + '/intuit-login')
    }
  },
  beforeMount () {
    if (this.$route.query.code === undefined || this.$route.query.state === undefined || this.$route.query.realmId === undefined) {
      return
    }
    api.authenticateIntuit(this.$route.query.code, this.$route.query.realmId)
      .then(() => {})
      .catch(err => { console.log(err) })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/IntuitLogin.vue